import { useQuery } from "@tanstack/react-query";
import { getSupplierMaterials } from "@/apis/supplier";

/**
 * 根据供应商编号及公司获取物料列表options
 * @param supplierCode
 * @param factoryValues
 * @returns
 */
export const useMaterialOptions = (supplierUserId: string) => {
  const result = useQuery({
    queryKey: ["querySupplierMaterials", supplierUserId],
    queryFn: () =>
      getSupplierMaterials({
        supplierUserId,
      }),
    enabled: !!supplierUserId,
  });

  const list = result.data?.data.data;

  const options = list?.map((m) => {
    return {
      label: m.materialCode
        ? `${m.materialName} ${m.materialCode}`
        : m.materialName,
      value: m.id,
    };
  });

  return options;
};
